ScoreTrekBattle.Dashboard = (function() {
    var _this;

    STATUS = {
        active: false,
        $view: null
    };

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('dashboard').then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            STATUS.active = false;
            STATUS.$view = null;
            resolve();
        });
    }

    _this = {
    };

    ScoreTrekBattle.View.register('/dashboard', onViewRender, onViewLoad, onViewUpdate, onViewUnload);

    return _this;
})();